import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
var Tether = function (_a) {
    var children = _a.children, target = _a.target, _b = _a.align, align = _b === void 0 ? 'bottom' : _b, _c = _a.offset, offset = _c === void 0 ? { vertical: 0, horizontal: 0 } : _c, _d = _a.show, show = _d === void 0 ? false : _d, onClose = _a.onClose;
    var portalContainer = useState(function () { return document.createElement('div'); })[0];
    var tetherRef = useRef(null);
    useEffect(function () {
        document.body.appendChild(portalContainer);
        return function () {
            document.body.removeChild(portalContainer);
        };
    }, [portalContainer]);
    useEffect(function () {
        if (!show)
            return;
        var handlePosition = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (target.current && tetherRef.current) {
                var targetRect = target.current.getBoundingClientRect();
                var tetherRect = tetherRef.current.getBoundingClientRect();
                var top_1;
                var left = void 0;
                switch (align) {
                    case 'top':
                        top_1 = targetRect.top - tetherRect.height - ((_a = offset.vertical) !== null && _a !== void 0 ? _a : 0);
                        left = targetRect.left + ((_b = offset.horizontal) !== null && _b !== void 0 ? _b : 0);
                        break;
                    case 'bottom':
                        top_1 = targetRect.bottom + ((_c = offset.vertical) !== null && _c !== void 0 ? _c : 0);
                        left = targetRect.left + ((_d = offset.horizontal) !== null && _d !== void 0 ? _d : 0);
                        break;
                    case 'left':
                        top_1 = targetRect.top + ((_e = offset.vertical) !== null && _e !== void 0 ? _e : 0);
                        left = targetRect.left - tetherRect.width - ((_f = offset.horizontal) !== null && _f !== void 0 ? _f : 0);
                        break;
                    case 'right':
                        top_1 = targetRect.top + ((_g = offset.vertical) !== null && _g !== void 0 ? _g : 0);
                        left = targetRect.right + ((_h = offset.horizontal) !== null && _h !== void 0 ? _h : 0);
                        break;
                    default:
                        return;
                }
                tetherRef.current.style.position = 'fixed';
                tetherRef.current.style.top = "".concat(top_1, "px");
                tetherRef.current.style.left = "".concat(left, "px");
            }
        };
        handlePosition();
        window.addEventListener('scroll', handlePosition, true);
        window.addEventListener('resize', handlePosition, true);
        var observer = new MutationObserver(handlePosition);
        if (target.current) {
            observer.observe(target.current, { attributes: true, childList: true, subtree: true });
        }
        return function () {
            window.removeEventListener('scroll', handlePosition, true);
            window.removeEventListener('resize', handlePosition, true);
            observer.disconnect();
        };
    }, [align, target, offset.vertical, offset.horizontal, show]);
    useEffect(function () {
        if (!show || !onClose)
            return;
        var handleClickOutside = function (event) {
            if (tetherRef.current &&
                !tetherRef.current.contains(event.target) &&
                target.current &&
                !target.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show, onClose, target]);
    if (!show)
        return null;
    return ReactDOM.createPortal(React.createElement("div", { ref: tetherRef, style: { position: 'fixed', zIndex: 1050 } }, children), portalContainer);
};
export default Tether;
